import type { SeasonMeetingCount } from '@multirx/shared/types/championship.js';

export interface CircuitPickerOption {
  id: number;
  name: string;
}

export function circuitPickerLabel(option: CircuitPickerOption): string {
  const trimmed = option.name.trim();
  return trimmed.length > 0 ? trimmed : `Circuit #${option.id}`;
}

export function trimCalendarToMeetingCount(calendar: number[], meetingCount: number): number[] {
  return calendar.slice(0, meetingCount);
}

export function isCalendarComplete(calendar: number[], meetingCount: number): boolean {
  if (calendar.length !== meetingCount) return false;
  return new Set(calendar).size === meetingCount;
}

export function toggleCircuitInCalendar(
  calendar: number[],
  circuitId: number,
  meetingCount: number
): number[] {
  const index = calendar.indexOf(circuitId);
  if (index >= 0) {
    return calendar.filter((id) => id !== circuitId);
  }
  if (calendar.length >= meetingCount) {
    return calendar;
  }
  return [...calendar, circuitId];
}

export function moveCalendarCircuit(
  calendar: number[],
  index: number,
  direction: -1 | 1
): number[] {
  const target = index + direction;
  if (target < 0 || target >= calendar.length) return calendar;
  const next = [...calendar];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
}

export function filterCalendarToAvailable(
  calendar: number[],
  availableIds: readonly number[]
): number[] {
  const available = new Set(availableIds);
  return calendar.filter((id) => available.has(id));
}

export function canStartSeasonWithCalendar(
  calendar: number[],
  meetingCount: SeasonMeetingCount,
  availableCount: number
): boolean {
  return availableCount >= meetingCount && isCalendarComplete(calendar, meetingCount);
}
